import { Clubhouse_LgRoundStatusV2 } from "../../enums";

/**
 * A round has started once someone is playing it, it is complete, or it is
 * finalized. Open is only the play window — teams stay editable until then.
 */
export function leagueRoundHasStarted(
  status?: Clubhouse_LgRoundStatusV2,
): boolean {
  return (
    status === Clubhouse_LgRoundStatusV2.InProgress ||
    status === Clubhouse_LgRoundStatusV2.Completed ||
    status === Clubhouse_LgRoundStatusV2.Finalized
  );
}

export function anyLeagueRoundStarted(
  rounds: { status?: Clubhouse_LgRoundStatusV2 }[] | undefined,
): boolean {
  return (rounds ?? []).some((round) => leagueRoundHasStarted(round.status));
}

/** Shown on a round's Teams board, which never edits membership. */
export const ROUND_TEAMS_LOCK_MESSAGE =
  "Teams are managed at the league level. Make changes on the League Participants tab before the first round starts.";

/**
 * Shown on the league Participants tab once the league is finalized and its
 * teams can no longer be rearranged a step at a time. Names the replacement
 * rather than just the refusal: every step on this board (create an empty team,
 * drop one player onto it, pull a player off) would leave the league holding a
 * team that is not full, so growth has to arrive as a whole team instead.
 */
export const LEAGUE_TEAMS_LOCK_MESSAGE =
  "Teams are set once the league is finalized. Use Add Team on the Roster tab to add a complete team.";
